var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.062,
    height: 13.375,
    viewBox: "0 0 20.062 13.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M19.941,10.679A11.172,11.172,0,0,0,10.031,4.5a11.173,11.173,0,0,0-9.91,6.179,1.127,1.127,0,0,0,0,1.017,11.172,11.172,0,0,0,9.91,6.179,11.173,11.173,0,0,0,9.91-6.179A1.127,1.127,0,0,0,19.941,10.679ZM10.031,16.2a5.016,5.016,0,1,1,5.016-5.016A5.016,5.016,0,0,1,10.031,16.2Zm0-8.359a3.32,3.32,0,0,0-.882.132,1.667,1.667,0,0,1-2.33,2.33,3.336,3.336,0,1,0,3.212-2.462Z",
    transform: "translate(0 -4.5)",
    fill: "#3357d9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.760471d7f6ed474ecf559021859e4796.svg";
export { ForwardRef as ReactComponent };